/**
 * Tenant Provider - Passthrough for static mode
 * TODO: Restore API-based bootstrap when recruitment backend is deployed
 */
import React from 'react'

export interface TenantProviderProps {
  children: React.ReactNode
}

/**
 * Static tenant provider — renders children directly without API calls
 */
export const TenantProvider: React.FC<TenantProviderProps> = ({ children }) => {
  return <>{children}</>
}
